import { t } from '@lingui/core/macro';
import { iconSlot, TertiaryIconButton, Tooltip } from '@luminovo/design-system';
import { styled } from '@mui/material';
import { ChevronRightIcon } from 'lucide-react';

import { DisplayColumnDef } from './tanstackTypes';

export const DEFAULT_EXPAND_COLUMN_ID = 'expand-col';

/** Keeps DataTableLegacy's full 24px chevron instead of the small icon button's 16px slot. */
const ExpandButton = styled(TertiaryIconButton)(iconSlot(24));

export const DefaultExpandColumn: DisplayColumnDef<any, unknown> = {
    id: DEFAULT_EXPAND_COLUMN_ID,
    size: 40,
    maxSize: 40,
    enableHiding: false,
    meta: {
        initialPinning: 'start',
        dataType: 'generic',
        enableOnRowClick: false,
        label: () => '',
    },
    header: ({ table }) => {
        const isAllExpanded = table.getIsAllRowsExpanded();

        return (
            <Tooltip variant="white" title={isAllExpanded ? t`Collapse all rows` : t`Expand all rows`}>
                <ExpandButton
                    aria-label={isAllExpanded ? t`Collapse all rows` : t`Expand all rows`}
                    size="small"
                    onClick={() => table.toggleAllRowsExpanded(!isAllExpanded)}
                    disableRipple
                >
                    <ChevronRightIcon
                        style={{
                            transform: isAllExpanded ? `rotate(90deg)` : `rotate(0deg)`,
                            transition: 'transform 0.1s ease-out',
                        }}
                    />
                </ExpandButton>
            </Tooltip>
        );
    },
    cell: ({ row }) => {
        return row.getCanExpand() ? (
            <ExpandButton
                aria-label={row.getIsExpanded() ? t`Collapse row` : t`Expand row`}
                size="small"
                onClick={() => row.toggleExpanded()}
                disableRipple
            >
                <ChevronRightIcon
                    style={{
                        transform: row.getIsExpanded() ? `rotate(90deg)` : `rotate(0deg)`,
                        transition: 'transform 0.1s ease-out',
                    }}
                />
            </ExpandButton>
        ) : (
            <></>
        );
    },
};
